export default {
    TEXT_INPUT: 'text-input',
    DROPDOWN_SELECTION: 'dropdown-selection',
    RADIO_BUTTONS: 'radio-buttons',
    DATE_PICKER: 'date-picker',
    CHECKBOXES: 'checkboxes',
    CURRENCY_INPUT: 'currency-input',
    TABLE_INPUT: 'table-input',
    UPLOAD_DOCUMENTS: 'upload-documents',
    SIC_CODE: 'sic-code',
}